<template>
	
	<div style="width:580px;margin:20px auto 0 auto;display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center">

          <el-form ref="form" :model="bonForm" label-width="100px" v-loading="layLoading">
            
           

             <el-form-item :label="$t('newAdd.모든베팅')" class="mb-0 " >
              <el-select :placeholder="$t('status.선택')" v-model="bonForm.bet_black" class="w-75 ">
                  <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
             <el-form-item v-if="this.user_type=='pt'" :label="$t('newAdd.머니회수')" class="mb-0 " >
              <el-select :placeholder="$t('status.선택')" v-model="bonForm.recy" class="w-75 ">
                  <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="this.user_type=='pt'" :label="$t('newAdd.머니이동')" class="mb-0 ">
              <el-select :placeholder="$t('status.선택')" v-model="bonForm.trans_black" class="w-75">
                  <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
         
          </el-form>
           <div class="d-flex mt-2" style="justify-content:center"><el-button type="primary" @click="bonSumbit()">{{$t('msg.수정')}}</el-button></div>
        
        
    

	</div>
</template>
<script>
	export default{
		props:{
		  info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
    
      layerid:{
        type:String,
        default:""
      },
		
		},
      created() {

       

          // this.info.id父组件传给子组件的id值
          
          this.fetchManage(this.info.id);

          this.user_type=this.info.user_type;
        
         
        
    },
		computed: {
         
            
        },
    	data(){
    		return{
          user_type:'',
          bonForm:{
            trans_black:'',
            bet_black:'',
            recy:'',
          },
         
           
           options1: [
               {
                label: this.$i18n.t("msg.가능"),
                 value: '0',
               
              }, {
                label: this.$i18n.t("msg.불가능"),
                 value: '1',
               
              }],
           options3: [
               {
                label: this.$i18n.t("msg.불가"),
                 value: '0',
               
              }, {
                label: this.$i18n.t("msg.가능"),
                 value: '1',
               
              }],
            options2: [
               {
                label: this.$i18n.t("msg.가능"),
                 value: '0',
               
              }, {
                label: this.$i18n.t("msg.불가능"),
                 value: '1',
               
              }],
    		  
           layLoading:false,
          
            domain:window.sessionStorage.getItem('domain'),
            userid:window.sessionStorage.getItem('userid'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            aid:window.sessionStorage.getItem('admin_id'),
            power:window.sessionStorage.getItem('power'),
            rosing:window.sessionStorage.getItem('rosing'),
    			
    		}
    	},
       mounted() {
        
            
    },
    	methods:{
         
      
         fetchManage(id){
          this.layLoading = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                  method:'get',
                   url:this.domain+'/admin/mem?mem_id='+id,
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.layLoading = false
                   let data = response.data.data
                   console.log('recom:',data)

                    this.bonForm.bet_black=data.bet_black
                    this.bonForm.trans_black =data.trans_black
                    this.bonForm.recy =data.recy
                   
                  
              
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
         },
         bonSumbit(){
          
               let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/mem_level_up',
                    data:{
                       bet_black:this.bonForm.bet_black,
                       trans_black:this.bonForm.trans_black,
                      recy:this.bonForm.recy,
                       id:this.info.id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:this.$i18n.t("msg.완료"),
                          type: 'success'
                        });
                          this.$layer.close(this.layerid);
                          this.getList();
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
         

       
    	
    	}
	}
</script>
<style>
/deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
</style>


// WEBPACK FOOTER //
// src/components/common/edit-layer.vue